/**
 * @module app.timeoutClassDirective
 */
import appBase from './index.js';

/**
 * @return {angular.Directive}
 * @ngInject
 */
const directive = function() {
  return {
    restrict: 'A',
    link:
        /**
         * @param {angular.Scope} $scope
         * @param {jQuery} element
         * @param {angular.Attributes} attrs
         */
        function($scope, element, attrs) {
          const appClass = attrs['appClass'];
          const appDuration = parseInt(attrs['appDuration'], 10);
          element.on('click', function(evt) {
            element.addClass(appClass);
            setTimeout(function() {
              element.removeClass(appClass);
            }, appDuration);
          });
        }
  };
};

export default appBase.directive('appTimeoutClass', directive);
